import { IsString, IsNumber, IsBoolean, IsOptional, MinLength, Min, IsMongoId, ValidateNested } from 'class-validator';
import { MultilingualTextDto } from '@/common/dto/multilingual-text.dto';
import { Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';

export class CreateStateDto {
    @ApiProperty({ type: MultilingualTextDto, description: 'State name in multiple languages' })
    @ValidateNested()
    @Type(() => MultilingualTextDto)
  name: MultilingualTextDto;

  @IsString()
  @MinLength(2)
  code: string;

  @IsNumber()
  @Min(0)
  shippingCost: number;

  @IsString()
  @IsMongoId()
  countryId: string;

  @IsOptional()
  @IsBoolean()
  isActive?: boolean = true;
}